import _classCallCheck from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Util } from './Util.js';
import { Layer } from './Layer.js';
import { _registerNode } from './Global.js';
export var FastLayer = /*#__PURE__*/function (_Layer) {
  _inherits(FastLayer, _Layer);

  var _super = _createSuper(FastLayer);

  function FastLayer(attrs) {
    var _this;

    _classCallCheck(this, FastLayer);

    _this = _super.call(this, attrs);

    _this.listening(false);

    Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    return _this;
  }

  return FastLayer;
}(Layer);
FastLayer.prototype.nodeType = 'FastLayer';

_registerNode(FastLayer);